import { useEffect, useMemo, useRef, useState } from 'react'
import './xqq.css'
import xxqfile from './xqq.docx'
import { renderAsync } from 'docx-preview'

export default function XQQ() {
    // Import qilingan DOCX fayl yo'lidan to'liq URL yasaymiz
    const docxUrl = useMemo(() => `${window.location.origin}${xxqfile}`, [])
    const containerRef = useRef(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        let isCancelled = false

        async function loadDoc() {
            setError(null)
            try {
                const res = await fetch(docxUrl, { cache: 'no-store' })
                if (!res.ok) throw new Error('Faylni yuklab bo\'lmadi')
                const blob = await res.blob()
                if (isCancelled) return
                if (containerRef.current) {
                    containerRef.current.innerHTML = ''
                    await renderAsync(blob, containerRef.current, undefined, {
                        inWrapper: true,
                        ignoreWidth: false,
                        ignoreHeight: false,
                        className: 'xqq_docx',
                        breakPages: true,
                        useMathMLPolyfill: true,
                    })
                }
            } catch (e) {
                if (!isCancelled) setError('Hujjatni ko\'rsatib bo\'lmadi')
            }
        }

        loadDoc()
        return () => { isCancelled = true }
    }, [docxUrl])

    return (
        <div className="xqq_page">
            <div className="xqq_doc_container" ref={containerRef} />
            {error && (
                <div className="xqq_fallback_card">
                    <p>{error}</p>
                    <a className="xqq_btn" href={docxUrl} target="_blank" rel="noreferrer">Hujjatni yuklab olish</a>
                </div>
            )}
        </div>
    )
}

